import { injectIntl } from 'react-intl';
import SearchResultsTable from './SearchResultsTable';

export default injectIntl(SearchResultsTable);
